module.exports = __webpack_public_path__ + "img/home-screen-device-iphone@3x.a6c766e7.png";